import { ComponentType, ReactNode } from 'react';
import { Route, RouteProps } from 'react-router-dom';

interface CustomRouteProps extends RouteProps {
  layout: ComponentType<{ children: ReactNode }>;
}

const CustomRoute = ({ component: Component, layout: Layout, ...rest }: CustomRouteProps) => {
  if (!Component) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default CustomRoute;
